var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 42C21 42 23.1 33.2706 28 28",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7665 16.8964L38.6403 25.9713C39.2072 31.8585 34.7932 37.1002 28.9061 37.6671C23.1296 38.2233 17.8967 34.0009 17.3405 28.2244C16.7842 22.4479 21.0161 17.3142 26.7926 16.758L36.4684 15.8263C37.1224 15.7634 37.7036 16.2425 37.7665 16.8964Z",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 51.3333C40.8866 51.3333 51.3333 40.8866 51.3333 28C51.3333 15.1133 40.8866 4.66663 28 4.66663C15.1133 4.66663 4.66666 15.1133 4.66666 28C4.66666 40.8866 15.1133 51.3333 28 51.3333Z",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng1);
export default __webpack_public_path__ + "static/media/png1.25170bd44dd5106e3c562065435be76e.svg";
export { ForwardRef as ReactComponent };